import { createContext, useContext } from "react";

export type UIConfig = {
    iconPath: (icon: string) => string;
    getLogger: (context: string) => Record<string, (...args: any[]) => void>;
    isIframed: () => boolean;
};

const defaultConfig: UIConfig = {
    iconPath: (icon) => icon,
    getLogger: (_componentName: string) =>
        ({
            mock: true,
            debug: () => {},
            log: () => {},
            warn: () => {},
            error: () => {},
            action: () => {},
        }) as unknown as Record<string, (...args: any[]) => void>,
    isIframed: () => false,
};

const UIConfigContext = createContext<UIConfig>(defaultConfig);

export const UIConfigProvider = UIConfigContext.Provider;

export const useUIConfig = (): UIConfig => useContext(UIConfigContext);
